import { render, staticRenderFns } from "./Mypackage.vue?vue&type=template&id=f5212d08&"
import script from "./Mypackage.vue?vue&type=script&lang=js&"
export * from "./Mypackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports